import { getSubscriptionAccess } from '../containers/Routes/utils';

export function getUserRedirectPath(user) {
  if (user.role === 'support') return false;
  if (!getSubscriptionAccess(user)) return '/billing';
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/authHelper.js